module.exports = __webpack_public_path__ + "static/media/player-down.11bff856.svg";